import React from "react";
import "./OptimizedImage.css";

/**
 * Responsive, natively lazy-loaded image.
 *
 * - `srcSet` / `sizes` let the browser download only the width it needs.
 * - Images below the fold use `loading="lazy"`; pass `priority` for an image
 *   that is part of the first screen (eager + high fetch priority).
 * - The container reserves its space and shows a flat placeholder colour, so
 *   nothing shifts while the file downloads.
 */
const OptimizedImage = ({
  src,
  srcSet,
  sizes,
  alt,
  className,
  width,
  height,
  onClick,
  thumbnailMode = false,
  priority = false,
  placeholderBgColor = "#f0f0f0",
}) => {
  const combinedClassName = `optimized-image ${className || ""} ${
    thumbnailMode ? "thumbnail-image" : ""
  }`.trim();

  return (
    <div
      className="image-container"
      style={{
        width: width || "100%",
        height: height || "100%",
        backgroundColor: placeholderBgColor,
      }}
    >
      <img
        src={src}
        srcSet={srcSet}
        sizes={srcSet ? sizes : undefined}
        alt={alt || ""}
        className={combinedClassName}
        onClick={onClick}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        decoding="async"
      />
    </div>
  );
};

export default OptimizedImage;
